import { useState, useEffect } from 'react';
import { getData } from '../utils/apiCalls';
import { imgs } from '../assets/imgs';
import { svgs } from '../assets/svgs';
import { useResizeImg } from '../hooks/useResizeImg';
import { Banner } from '../components';
import { Link } from 'react-router-dom';
import { tracking } from '../utils/tracking';

export const FAQ = () => {
   document.title = "New York Venture Summit | FAQ";
   const [data, setData] = useState([])
   const [questionsMap, setQuestionsMap] = useState([]);
   const [isLoading, setIsLoading] = useState(true)
   const imageSource = useResizeImg(imgs.startups.startupBannerDesktop, imgs.startups.startupBannerMobile)


   useEffect(() => {
      getData('https://youngstartup.io/api/cwebsite/get_faq')
         .then((data) => {
            data.forEach(category =>
               category.values.forEach(value =>
                  questionsMap.push({ id: value.id, isOpen: false })))
            setData(data)
         }).then(setIsLoading(false))
   }, []);  

   const handleClick = (value) => {
      const clickedQuestion = questionsMap.find(q => q.id === value.id)
      clickedQuestion.isOpen = !clickedQuestion.isOpen
      const newQuestionsMap = questionsMap.filter(q => q.id !== value.id)
      setQuestionsMap([...newQuestionsMap, clickedQuestion])
   }

   return (
      <div className='faq-page'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1>FAQs</h1>
               <h2>Please see our comprehensive list of FAQs below</h2>
            </section>
            <section>
            <Link to='/registration' onClick={() => tracking(346)} className="btn b2">GET YOUR TICKET</Link>
            </section>
         </Banner>
         <div className='faqContainer'>
            {isLoading && <div id='loader' ></div>}
            {
               data.map(category =>
                  <div className='faqCategory'>
                     <section className='categoryName'>
                        <h4>{category.name}</h4>
                     </section>
                     <section className='qsAndAs'>
                        {
                           category.values.map(value =>
                              <div className='qaItem' onClick={() => handleClick(value)}  >
                                 <h4 className={questionsMap.find(q => q.id === value.id).isOpen ? 'q open' : 'q'}>
                                    {value.q}
                                    {svgs.arrowDown}
                                 </h4>
                                 <h4 className={questionsMap.find(q => q.id === value.id).isOpen ? 'ans open' : 'ans'} dangerouslySetInnerHTML={{ __html: value.ans }} ></h4>
                              </div>
                           )
                        }
                     </section>
                  </div>
               )
            }
         </div >
      </div >
   );
};
